var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusUnderMaintenance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6093_19105)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99999 0C9.30824 0 12 2.69176 12 5.99999C12 9.30821 9.30824 12 5.99999 12C2.69176 12 0 9.30824 0 5.99999C0 2.69176 2.69176 0 5.99999 0ZM6.02569 3.24697C5.45661 2.81413 4.71271 2.66487 4.17957 2.78544L5.10263 3.7085L4.6411 4.63157L3.71804 5.09312L2.79495 4.17006C2.67438 4.7032 2.82364 5.4471 3.25648 6.01619C3.8466 6.47007 4.57256 6.62318 5.1026 6.47772L7.20832 8.4767C7.60762 8.82901 8.00693 8.80553 8.40625 8.40625C8.8305 7.98199 8.8305 7.55772 8.40625 7.13345C7.10875 5.86046 6.46908 5.18035 6.48725 5.09312C6.63266 4.56311 6.47955 3.83712 6.02572 3.247",
    fill: "#F2841B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6093_19105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusUnderMaintenance);
export default __webpack_public_path__ + "static/media/Status Under Maintenance.c428385cf41a410145740d3ccc763a4a.svg";
export { ForwardRef as ReactComponent };